module.exports = __webpack_public_path__ + "img/jungong-1.79efb775.png";